<template>
  <div class="w-full lg:w-64 flex-shrink-0">
    <div
      class="bg-white rounded-xl shadow-sm border border-neutral-200 overflow-hidden sticky top-24"
    >
      <nav class="flex flex-col p-2">
        <button
          v-for="menu in menus"
          :key="menu.id"
          @click="$emit('select', menu.id)"
          :class="[
            'flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-all mb-1',
            currentMenu === menu.id
              ? 'bg-primary/10 text-primary'
              : 'text-neutral-600 hover:bg-neutral-50',
          ]"
        >
          <i :class="['fa w-6 text-center mr-2', menu.icon]"></i>
          <span class="flex-1 text-left">{{ menu.name }}</span>
          <span
            v-if="menu.badge > 0"
            class="ml-2 min-w-[20px] h-5 px-1.5 rounded-full text-xs font-bold flex items-center justify-center"
            :class="
              currentMenu === menu.id
                ? 'bg-primary text-white'
                : 'bg-red-500 text-white'
            "
            >{{ menu.badge > 99 ? "99+" : menu.badge }}</span
          >
        </button>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSidebar",
  props: {
    menus: {
      type: Array,
      required: true,
    },
    currentMenu: {
      type: String,
      required: true,
    },
  },
  emits: ["select"],
};
</script>
